import React, { Component } from "react";
import { EventDispatcher } from "../../../eventing";

export const AnnotationContext = React.createContext({
  annotation: null,
  isEditingAnnotation: () => null,
  setAnnotation: () => null,
  saveAnnotation: () => null,
  setEditing: () => null,
  isEditing: () => null,
  subscribe: () => null,
  unsubscribe: () => null
});

class AnnotationServiceProvider extends Component {
  // provides semi-global state to edit (rescribe) a single annotation
  state = { annotation: null, editing: false };

  dispatcher = new EventDispatcher();

  setAnnotation = annotation => {
    this.setState(state => ({ ...state, annotation: annotation }));
    this.dispatcher.dispatch("update.annotation", annotation);
  };

  setEditing = value => {
    this.setState(state => ({ ...state, editing: value, annotation: null }));
    this.dispatcher.dispatch("update.editing", value);
  };

  saveAnnotation = a => {
    this.dispatcher.dispatch("save.annotation", a || this.state.annotation);
  };

  isEditingAnnotation = annotation =>
    this.state.editing &&
    this.state.annotation &&
    this.state.annotation.id === annotation.id;

  isEditing = () => this.state.editing;

  subscribe = (...args) => {
    this.dispatcher.subscribe(...args);
  };

  unsubscribe = (...args) => {
    this.dispatcher.unsubscribe(...args);
  };

  render() {
    return (
      <AnnotationContext.Provider
        value={{
          annotation: this.state.annotation,
          setAnnotation: this.setAnnotation,
          saveAnnotation: this.saveAnnotation,
          setEditing: this.setEditing,
          isEditing: this.isEditing,
          isEditingAnnotation: this.isEditingAnnotation,
          subscribe: this.subscribe,
          unsubscribe: this.unsubscribe
        }}
      >
        {this.props.children}
      </AnnotationContext.Provider>
    );
  }
}

export default AnnotationServiceProvider;
